var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E5E5E4;}\r\n\t.st1{fill:#1d3943;}\r\n\t.st2{fill:#C2D6D2;}\r\n\t.st3{fill:#1DA092;}\r\n\t.st4{fill:#1C3445;}\r\n\t.st5{fill:#DFDFDE;}\r\n\t.st6{fill:#1d3943;}\r\n\t.st7{fill:#B7CDC8;}\r\n\t.st8{fill:#239281;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4425_00000162344196689710893070000005227538600130063759_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1_00000086677458213268295140000005785851427872869013_",
    className: "st5",
    d: "M1182.1,1464.5 c-101.1,0-197.8-4.4-298.8-4.4s-175.8-39.6-197.8-127.4c-30.8-83.5-4.4-175.8,57.1-237.3c259.3-276.9,514.2-553.7,773.5-830.6 c87.9-92.3,206.6-101.1,276.9-13.2c79.1,92.3,70.3,210.9-22,312c-145,158.2-294.4,312-439.5,470.2c-13.2,13.2-26.4,30.8-39.6,48.3 c114.3,0,224.1,4.4,329.6,4.4c79.1,0,118.7,61.5,180.2,131.8c52.7,65.9,8.8,167-48.3,228.5c-83.5,83.5-162.6,162.6-259.3,254.9 c96.7,101.1,180.2,193.4,263.7,281.3c109.9,123.1,87.9,285.7-52.7,351.6c-70.3,30.8-153.8,13.2-202.2-48.3 c-127.4-145-259.3-290.1-386.7-435.1c-79.1-83.5-79.1-210.9,4.4-294.4c22-26.4,48.3-48.3,70.3-70.3L1182.1,1464.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_00000076589682871333957970000018166424129326232490_",
    className: "st6",
    d: "M1006.3,1657.9l584.5-597.7 c17.6-17.6,48.3-22,70.3,0l0,0l202.2,206.6c17.6,22,17.6,52.7,0,70.3l-580.1,597.7c-17.6,17.6-48.3,22-70.3,0l0,0l-202.2-206.6 C988.8,1706.2,988.8,1675.4,1006.3,1657.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_00000126316333255796658830000000222015682236608640_",
    className: "st7",
    d: "M1476.6,2110.5 c26.4-101.1,131.8-162.6,237.3-136.2c0,0,0,0,4.4,0c105.5,30.8,162.6,140.6,131.8,241.7c-26.4,101.1-131.8,162.6-237.3,136.2 c0,0,0,0-4.4,0C1507.3,2321.5,1445.8,2211.6,1476.6,2110.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_00000094577999090760678370000014043650825530776494_",
    className: "st8",
    d: "M1902.9,431.7L865.7,1486.5 c-17.6,17.6-48.3,17.6-70.3,0l0,0l-202.2-206.6c-17.6-22-17.6-52.7,0-70.3L1630.4,154.9c17.6-17.6,48.3-17.6,70.3,0l0,0 l206.6,210.9C1924.8,379,1924.8,414.1,1902.9,431.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexModalIcon);
export default __webpack_public_path__ + "static/media/flex_modal_icon.eab5391a51f48301636969984341713d.svg";
export { ForwardRef as ReactComponent };